import { LeftOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import env from "shared/constants/env";
import { useTranslation } from "../../../contexts/TranslationContext";
import AcceptModal from "./AcceptModal";
import CancelModal from "./CancelModal";

import { LoadingOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { getUpgradeFlag } from "services/lookupSelector";
import routes, { appRoute } from "shared/constants/routes";

// Helper function to get the correct endpoint based on application source
const getEndpointForApp = (appId) => {
  const upgradedUser = getUpgradeFlag();

  // For v2 users, always use v2 endpoint
  // if (upgradedUser) {
  //   return env.API_ENDPOINT_V2;
  // }

  // For v1 users, check application source
  try {
    const appSourceMap = JSON.parse(localStorage.getItem('userAppsSourceMap') || '{}');
    if (appSourceMap[appId]) {
      return appSourceMap[appId] === 'v1' ? env.API_ENDPOINT : env.API_ENDPOINT_V2;
    }
  } catch (error) {
    console.error("Error checking cached app source:", error);
  }

  // Fallback to v1 for v1 users
  return env.API_ENDPOINT;
};

function ViewContract() {
  const { appId, contractStatus } = useParams();
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [pdfURL, setpdfURL] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPdf = async (appId) => {

    try {
      const baseEndpoint = getEndpointForApp(appId);
      let response = null;
      if (contractStatus === "SIGNED") {
        response = await fetch(`${baseEndpoint}app/get-signed-contract?appId=${appId}`);
      } else if (contractStatus === "GENERATED") {
        response = await fetch(`${baseEndpoint}app/get-unsigned-contract`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ appId: appId }),
        });
      }

      const data = await response.json();

      // Handle different response formats based on API version
      let base64String = null;

      // Determine response format based on the actual endpoint used
      const isV2Endpoint = baseEndpoint === env.API_ENDPOINT_V2;

      if (isV2Endpoint) {
        // V2 API response format
        if (data?.payload?.content && data?.payload?.content.length > 0 && data?.success) {
          base64String = data.payload.content;
        }
      } else {
        // V1 API response format
        if (data?.contract && data?.contract.length > 0) {
          base64String = data.contract;
        }
      }

      if (base64String) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setpdfURL(url);
      } else {
        toast.error(data?.message || `Couldn't read contract`);
        navigate(appRoute(routes.HOME));
      }
    } catch (error) {
      toast.error("Couldn't read contract");
      navigate(appRoute(routes.HOME));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!appId) {
      navigate(routes.HOME);
      toast.error("Application ID was not specified.");
      return;
    }

    fetchPdf(appId);
  }, [appId, navigate]);

  return (
    <div>
      <Card>
        <div className="flex items-center gap-4">
          <div onClick={() => navigate(`/app/${routes.HOME}`)} className="border border-gray-200 cursor-pointer w-8 h-8 rounded-lg flex items-center justify-center">
            <LeftOutlined />
          </div>
          <h1 className="font-bold text-2xl">{translate("CONTRACT.CONTRACT")}</h1>
        </div>

        {loading && (
          <div className="mt-5">
            Loading &nbsp;
            <LoadingOutlined />
          </div>
        )}

        {pdfURL && (
          <div className="mt-5">
            <iframe src={pdfURL} width="100%" height="600px" title="Contract Viewer"></iframe>

            {contractStatus === "GENERATED" && (
              <div className="flex items-center justify-center gap-2 mt-5">
                <CancelModal appId={appId} />
                <AcceptModal appId={appId} />
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}

export default ViewContract;
